import { createContext } from 'react';

export const SsrApiDataContext = createContext<Record<string, unknown>>({});
